import React from 'react'

// react router dom
import { Link } from 'react-router-dom';

export default function OrdersListView(props) {
    const {
        dataItem,
    } = props

    return (
        <tr>
            <td className="order-id">
                <Link to={`/account/orders/details/${dataItem.order_id}`} className="mb-0 hover-underline-link st-fw-600">
                    {dataItem.order_id}
                </Link>
            </td>
            <td className="order-date1">
                <p className="mb-0">
                    {dataItem.order_date}
                </p>
            </td>
            <td className="sub-total">
                <p className="mb-0">
                    {dataItem.order_amount}
                </p>
            </td>
            <td className="order-payment-status">
                <p className={`mb-0`}>
                    <span className={`st-fw-600 text-capitalize`}>
                        {
                            dataItem?.payment_status && dataItem.payment_status.toLowerCase().replaceAll("_", " ")
                        }
                    </span>
                </p>
            </td>
            <td className="order-payment-status">
                <p className={`mb-0`}>
                    <span className={`st-fw-600 text-capitalize`}>
                        {
                            dataItem?.fullfillment_status && dataItem.fullfillment_status.toLowerCase().replaceAll("_", " ")
                        }
                    </span>
                </p>
            </td>
            <td className="actions-td">
                <div className="d-flex align-items-center">
                    <div className="link-container me-2">
                        <Link to={`/account/orders/details/${dataItem.order_id}`} className="link text-capitalize text-decoration-none">view order details</Link>
                    </div>
                    {/* <div className="link-container ms-2">
                        <a href="/" className="link text-capitalize text-decoration-none">reorder</a>
                    </div> */}
                </div>
            </td>
        </tr>
    )
}
